<template>
  <!-- class="MainPage" -->
  <div>
    <el-header style="background-color: #f7f7f7; padding: 0">
      <div style="display: flex; align-items: center">
        <div style="width: 100%; position: relative">
          <el-menu
            :default-active="activeName"
            class="el-menu-demo"
            mode="horizontal"
            router
            active-text-color="#409EFF"
          >
            <el-menu-item
              :index="item.path"
              v-for="item in routerList"
              :key="item.path"
              style="display: flex; align-items: center"
              ><i :class="item.icon"></i> {{ item.title }}</el-menu-item
            >
          </el-menu>
          <div
            style="
              background-color: #fff;
              height: 60px;
              position: absolute;
              right: 20px;
              top: 0;
            "
          >
            <div style="display: flex; align-items: center; height: 100%">
              <el-button
                type="primary"
                size="mini"
                style="
                  width: 60px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin-right: 10px;
                "
                icon="el-icon-question"
                >帮助</el-button
              >
              <div style="font-size: 14px; width: 140px">{{ date }}</div>
              <div
                style="margin-left: 10px; margin-right: 15px; cursor: pointer"
                @click="openInfo"
              >
                <el-badge
                  :value="UnreadTotal"
                  :max="99"
                  :hidden="UnreadTotal == 0"
                >
                  <i
                    class="el-icon-chat-line-round"
                    style="font-size: 30px; color: #909399"
                  ></i>
                </el-badge>
              </div>
              <div
                style="margin: 0px 15px; cursor: pointer"
                @click="handleShowUserInfo"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="op().Name || op().NickName || op().Phone"
                  placement="bottom"
                  :open-delay="450"
                >
                  <el-avatar
                    :size="40"
                    :src="op() ? op().Icon : null"
                    icon="el-icon-user-solid"
                  ></el-avatar>
                </el-tooltip>
              </div>
              <div
                style="font-size: 14px; cursor: pointer"
                @click="handleShowUserInfo"
              >
                {{ op().Name || op().NickName || op().Phone }}
              </div>
              <div
                style="margin: 0px 15px; cursor: pointer"
                @click="handleExit"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="退出登录"
                  placement="bottom"
                  :open-delay="450"
                >
                  <i
                    class="el-icon-switch-button"
                    style="font-size: 30px; font-weight: 900; color: #409eff"
                  ></i>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-header>
    <el-main
      style="height: calc(100vh - 61px); padding: 0; background-color: #f7f7f7"
    >
      <el-card
        style="height: calc(100% - 2px)"
        :body-style="{
          padding: '0',
          height: '100%',
          overflowY: 'auto',
        }"
      >
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>

        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </el-card>
    </el-main>
    <News ref="News" @close="getMessageCount"></News>
  </div>
</template>

<script>
import TokenCache from '@/utils/cache/TokenCache'
import moment from 'moment'
import { mapState } from 'vuex'
import News from './News.vue'
export default {
  name: 'MainPageLayout',
  components: { News },
  data() {
    return {
      date: '',
      inputValue: '', //项目任务搜索
      // 通知个数
      UnreadTotal: '',
      menuKey: 'All',
      activeName: '/File',
      backShow: -1, // 后退按钮显示
      modelShow: false,
      APRList: [],
      routerList: [
        {
          path: '/ProjectView',
          title: '项目',
          icon: 'el-icon-notebook-2',
        },
        // {
        //   path: "/Project/All",
        //   title: "项目",
        //   icon: "el-icon-s-order",
        // },
        // {
        //   path: "/Mail",
        //   title: "通讯录",
        //   imgSrc: Contacts,
        // },
        {
          path: '/Supplier',
          title: '供应商总目录',
          icon: 'icon-gongyingshang1 icon',
        },
        {
          path: '/PMC',
          title: '物业单位目录',
          icon: 'el-icon-house',
        },
        //  {
        //           path: "/DesignPattern",
        //           title: "模板",
        //           // imgSrc: Participate,
        //           icon:'el-icon-notebook-2'
        //         },
      ],
      ProjectMenu: [
        { name: 'All', label: '全部项目' },
        // { name: "second", label: "参与项目" },
        // { name: "third", label: "我的项目" },
        // { name: "collect", label: "收藏项目" },
      ],
      TaskMenu: [
        { name: 'TaskAll', label: '全部任务' },
        { name: 'Tasksecond', label: '参与任务' },
        { name: 'Taskthird', label: '我的任务' },
      ],
    }
  },
  computed: {
    ...mapState(['searchValue']),
  },
  async mounted() {
    this.date = moment().format('YYYY-MM-DD HH:mm:ss')
    setInterval(() => {
      this.date = moment().format('YYYY-MM-DD HH:mm:ss')
    }, 1000)
    // this.activeName = this.$route.path;
    this.menuKey = this.$route.params.type
    // this.getMessageCount()
    // this.$http
    //   .post("/Base_ProjectManage/Project_DictionaryMain/GetTheDataByDicKey", {
    //     Condition: "DicKey",
    //     Keyword: "APR_HuaRunProjects",
    //   })
    //   .then((res) => {
    //     if (res.Success) {
    //       this.APRList = res.Data.DictionaryDetailsList;
    //     }
    //   });
  },
  watch: {
    $route: {
      handler(n, o) {
        if (n.path.indexOf('ProjectInfo') > -1) {
          this.activeName = '/ProjectView'
        } else {
          this.activeName = n.path
        }
        console.log(this.activeName, '444444')
        this.backShow = this.routerList.findIndex((item) => item.path == n.path)
        this.getMessageCount()
      },
      deep: true,
      immediate: true,
    },
    searchValue(value, n) {
      this.inputValue = value
    },
  },
  methods: {
    openInfo() {
      this.$refs.News.openDrawer(this.op().Id)
    },
    alive() {
      console.log(this.$route, '=====================================')
      return true
    },
    handleSelect() {},
    Search() {
      this.$store.commit('setSearchValue', this.inputValue)
    },

    // 获取通知
    getMessageCount() {
      this.$http
        .post(
          '/Operation_Manage/Operation_Notify/GetAdminSideOperationNotifyCount',
          {
            Search: [
              {
                Condition: 'ProjectManagerId',
                Keyword: this.op().Id,
              },
            ],
          }
        )
        .then((res) => {
          if (res.Success) {
            this.UnreadTotal = res.Data || 0
          }
        })
    },

    op() {
      return this.$store.state.userInfo
    },

    //获取用户信息
    handleShowUserInfo() {
      this.$router.push('/My')
    },
    //退出账号
    handleExit(e) {
      this.$confirm('确认退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          TokenCache.deleteToken()
          this.$store.state.userInfo = {}
          this.$store.state.isLogin = false
          this.$router.replace('/Home')
        })
        .catch(() => {})
    },
  },
}
</script>
<style lang="scss" scoped>
$color: #409eff; // 主题色
$hoverBG: rgb(246, 247, 249); // 悬浮选中背景色

::v-deep .el-badge__content.is-fixed {
  top: 7px !important;
}

::v-deep .el-menu--horizontal > .el-menu-item {
  margin: 0 10px;
}

::v-deep .el-avatar img {
  display: block;
  height: 100%;
  width: 100%;
  vertical-align: middle;
}

.MainPage {
  height: 100%;
  display: flex;

  .pageRight {
    width: calc(100vw - 80px);
    // flex: 1;
    display: flex;
    flex-direction: column;
  }

  .nav {
    display: flex;
    text-align: center;
    flex-direction: column;
    width: 80px;
    box-shadow: 0 1px 5px 0 rgb(57 66 60 / 20%);
    z-index: 999;
    background: #fff;

    .logo {
      height: 70px;
      line-height: 70px;
      margin: 10px auto;

      img {
        padding: 8px 0 0 0;
        width: 50%;
      }
    }

    ul {
      li {
        margin-bottom: 8px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;

        .navActive {
          color: $color;
          background-color: $hoverBG;
        }

        .navItem {
          width: 70px;
          height: 59px;
          border-radius: 8px;
          font-size: 12px;
          color: #aaa;
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          cursor: pointer;

          img {
            width: 27px;
          }
        }

        .navItemTitle {
          margin-top: 2px;
        }

        .navItem:hover {
          background: $hoverBG;
        }
      }
    }
  }

  .menuT {
    display: flex;
    flex-direction: column;
    width: 150px;

    padding: 0 10px;
    box-sizing: border-box;
    z-index: 998;
    background: #fff;
    border-right: 1px solid #efefef;

    .title {
      padding: 20px 0;
      font-weight: 600;
      font-size: 18px;
    }

    .menuItem {
      font-size: 14px;
      padding: 7px 10px;
      border-radius: 5px;
      margin-bottom: 5px;
      cursor: pointer;

      &:hover {
        background: #fae7e7;
        color: #409eff;
        font-weight: 600;
      }
    }

    .menuActive {
      background: #fae7e7;
      color: #409eff;
      font-weight: 600;
    }
  }

  .mask {
    width: calc(100% - 80px);
    height: 100vh;
    background: transparent;
    position: fixed;
    left: 80px;
    top: 0;
    z-index: 9999;

    .modelShow {
      position: absolute;
      width: 100px;
      height: 500px;
      border-radius: 10px;
      box-shadow: 1px 3px 5px #ccc;
      background: #fff;
      top: 70px;
      left: 10px;
      overflow: hidden;
    }
  }
}

.serinput {
  margin-top: 20px;
}

.prefix {
  display: flex;
  height: 100%;
  align-items: center;
  margin-left: 5px;
  cursor: pointer;
}
</style>
